import { Decorator } from './decorator';

export function replaceTargetRoasOfQuery(query, key) {
  if (!query) return query;
  const finalQuery = { ...query };
  if (key in finalQuery) {
    const filterTargetRoas = finalQuery[key];
    Object.keys(filterTargetRoas).forEach((qKey) => {
      // eslint-disable-next-line no-param-reassign
      finalQuery[key][qKey] = parseFloat((filterTargetRoas[qKey] / 100.0).toFixed(4));
    });
  } else if ('$and' in finalQuery) {
    finalQuery.$and.forEach((value, index, array) => {
      if (key in value) {
        const filterTargetRoas = array[index][key];
        Object.keys(filterTargetRoas).forEach((qKey) => {
          // eslint-disable-next-line no-param-reassign
          array[index][key][qKey] = parseFloat((filterTargetRoas[qKey] / 100.0).toFixed(4));
        });
      }
    });
  }
  return finalQuery;
}


export class TargetRoasFilterProcessorDecorator extends Decorator {
  constructor({
    featureName,
  }) {
    super({ name: 'target-roas-filter-processor' });

    this.featureName = featureName;
  }

  getValueAsync() {
    // eslint-disable-next-line no-restricted-globals
    return Promise.resolve();
  }

  buildQuery(queryParams) {
    const finalWhere = replaceTargetRoasOfQuery(
      queryParams.where,
      'DisplayBiddingStrategyTargetRoas'
    );

    return {
      ...queryParams,
      where: finalWhere,
    };
  }
}
